import { createRouter, createWebHistory } from 'vue-router'
import Header from '@/components/common/Header.vue'
import Footer from '@/components/common/Footer.vue'
import HeaderEmployee from '@/components/common/HeaderEmployee.vue'
import FooterEmployee from '@/components/common/FooterEmployee.vue'
import PostJobSuccess from '../views/PostJobSuccess.vue';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'employer-zone',
      components: {
        default: () => import("../views/EmployerZone.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      components: {
        default: () => import("../views/Dashboard.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/number-of-job-application',
      name: 'NumberOfJobApplication',
      components: {
        default: () => import("../views/NumberOfJobApplication.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/about',
      name: 'About',
      components: {
        default: () => import("../views/About.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/postjoblist',
      name: 'Totalpostedjob',
      props: true,
      components: {
        default: () => import("../views/Totalpostedjob.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/contractjoblist',
      name: 'TotalPostedContractJob',
      props: true,
      components: {
        default: () => import("../views/TotalPostedContractJob.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/active-job-posting',
      name: 'NumberJobPosting',
      components: {
        default: () => import("../views/NumberJobPosting.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/register',
      name: 'Register',
      props: true,
      component: () => import("../views/Register.vue"),
    },
    {
      path: '/congratulations',
      name: 'RegistrationCongratulationModal',
      props: true,
      component: () => import("../components/Modal/RegistrationCongratulationModal.vue"),
    },
    {
      path: '/login',
      name: 'Login',
      props: true,
      components: {
        default: () => import("../views/Login.vue"),
        // head: Header,
        // footer: Footer,
      }
    },
    {
      path: '/employer-login',
      name: 'EmployerLogin',
      props: true,
      components: {
        default: () => import("../views/Login.vue"),
        // head: Header,
        // footer: Footer,
      }
    },
    {
      path: '/gulfworker-login',
      name: 'LoginOffshore',
      props: true,
      components: {
        default: () => import("../views/LoginOffshore.vue"),
        // head: Header,
        // footer: Footer,
      }
    },
    {
      path: '/post-job/success',
      name: 'PostJobSuccess',
      component: PostJobSuccess,
      props: true,

    },
    {
      path: '/post-job/:jobid*',
      name: 'PostJob',
      components: {
        default: () => import("../views/PostJob.vue"),
        // head: Header,
        // footer: Footer,
      }
    },
    {
      path: '/labour-contractor/:jobid*',
      name: 'PostContractJob',
      components: {
        default: () => import("../views/PostContractJob.vue"),
        // head: Header,
        // footer: Footer,
      }
    },

    {
      path: '/gulfworker',
      name: 'PostOffshoreJob',
      components: {
        default: () => import("../views/PostOffshoreJob.vue"),
        // head: Header,
        // footer: Footer,
      }
    },
    {
      path: '/active-job-application/:jobid',
      name: 'JobApplication',
      components: {
        default: () => import("../views/JobApplication.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/contract-job-application/:jobid',
      name: 'ContractJobApplication',
      components: {
        default: () => import("../views/ContractJobApplication.vue"),
        head: Header,
        footer: Footer,
      }
    },

    {
      path: '/job-applications',
      name: 'SearchResume',
      components: {
        default: () => import("../views/SearchResume.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/hire-:skill-in-:location',
      name: 'SearchResumeList',
      components: {
        default: () => import("../views/SearchResumeList.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/get-matching-resume/:jobid*',
      name: 'SearchMatchingResume',
      components: {
        default: () => import("../views/SearchMatchingResume.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/hire-:skill',
      name: 'SearchResumeListWithoutCity',
      components: {
        default: () => import("../views/SearchResumeList.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/hireemployee',
      name: 'ChooseEmployee',
      components: {
        default: () => import("../views/Choose-Employee.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/find-resume',
      name: 'FindResume',
      components: {
        default: () => import("../views/FindResume.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/company-profile',
      name: 'CompanyProfile',
      components: {
        default: () => import("../views/CompanyProfile.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/saved-resume-list',
      name: 'SavedResume',
      components: {
        default: () => import("../views/SavedResume.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/saved-resume',
      name: 'SavedResumeLanding',
      components: {
        default: () => import("../views/SavedResumeLanding.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/auto-login',
      name: 'autologin',
      components: {
        default: () => import("../views/redirection/autologin.vue"),
      }
    },
    {
      path: '/matching-resume',
      name: 'MatchingResume',
      components: {
        default: () => import("../views/MatchingResume.vue"),
        head: Header,
        footer: Footer,
      }
    },

    {
      path: '/setting',
      name: 'Setting',
      components: {
        default: () => import("../views/EmployerSetting.vue"),
        head: Header,
        footer: Footer,
      }
    },

    {
      path: '/employee-view-profile/:empid',
      name: 'EmployeUpdateProfile',
      components: {
        default: () => import("../views/employee/EmployeUpdateProfile.vue"),
        head: Header,
        footer: Footer,
      }
    },

    {
      path: '/employee-profile/:jobid/:empid',
      name: 'EmployeeProfile',
      components: {
        default: () => import("../views/EmployeeProfile.vue"),
        head: Header,
        footer: Footer,
      }
    },

    {
      path: '/employer-plan',
      name: 'EmployerPlan',
      components: {
        default: () => import("../views/plan/index.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/database-new',
      name: 'EmployerNewDatabasePlan',
      components: {
        default: () => import("../views/DatabaseNew.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/hiring-plans',
      name: 'Plans',
      components: {
        default: () => import("../views/PlansNew.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/special-plan',
      name: 'SpecialOfferPlan',
      components: {
        default: () => import("../views/SpecialOfferPlan.vue"),
        // head: Header,
        // footer: Footer,
      }
    },
    {
      path: '/payment-success',
      name: 'PaymentSuccess',
      components: {
        default: () => import("../views/PaymentSuccess.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/payment-failure',
      name: 'PaymentFailure',
      components: {
        default: () => import("../views/PaymentFailure.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/subscription',
      name: 'Subscription',
      components: {
        default: () => import("../views/Subscription.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/active-post-jobs',
      name: 'activePostJobs',
      components: {
        default: () => import("../views/ActiveJobPosts.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/checkout/:orderId',
      name: 'Checkout',
      components: {
        default: () => import("../views/Checkout.vue"),
        // head: Header,
        // footer: Footer,
      },
      props: true, // Enable props for this route
    },
    {
      path: '/viewjobpost/:jobid',
      name: 'ViewJobDetails',
      components: {
        default: () => import("../views/ViewJobDetails.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/viewContractjobpost/:jobid',
      name: 'ViewContractJobDetails',
      components: {
        default: () => import("../views/ViewContractJobDetails.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/notifications',
      name: 'Notification',
      components: {
        default: () => import("../views/Notification.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/comming-soon',
      name: 'Commingsoon',
      components: {
        default: () => import("../views/HireStaffByCity.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/hire-*',
      name: 'Commingson',
      components: {
        default: () => import("../views/HireStaffByCity.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/feedback',
      name: 'Feedback',
      components:
      {
        default: () => import("../views/Feedback.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/feedback/:id',
      name: 'FeedbackForm',
      components: {
        default: () => import("../views/FeedbackForm.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/thank-you',
      name: 'Thankyou',
      components: {
        default: () => import("../views/ThankYou.vue"),
        head: Header,
        footer: Footer,
      }
    },
    // //Employee Routes
    // {
    //   path: '/login',
    //   name: 'Login',
    //   components: {
    //     default: () => import("../views/employee/Login.vue"),
    //     head: HeaderEmployee,
    //     footer: FooterEmployee,
    //   }
    // },
    {
      path: '/jobdetails',
      name: 'JobDetails',
      components: {
        default: () => import("../views/employee/JobDetails.vue"),
        head: HeaderEmployee,
        footer: FooterEmployee,
      }
    },
    {
      path: '/joblisting',
      name: 'JobListing',
      components: {
        default: () => import("../views/employee/JobListing.vue"),
        head: HeaderEmployee,
        footer: FooterEmployee,
      }
    },

    {
      path: '/employee-profile',
      name: 'EmployeeProfile',
      components: {
        default: () => import("../views/employee/EmployeeProfile.vue"),
        head: HeaderEmployee,
        footer: FooterEmployee,
      }
    },
    {
      path: '/employee-dashbord',
      name: 'EmployeeDashbord',
      components: {
        default: () => import("../views/employee/EmployeeDashbord.vue"),
        head: HeaderEmployee,
        footer: FooterEmployee,
      }
    },


    {
      path: '/aboutus',
      name: 'AboutUS',
      components: {
        default: () => import("../views/employee/About.vue"),
        head: HeaderEmployee,
        footer: FooterEmployee,
      }
    },
    {
      path: '/faq',
      name: 'FAQ',
      components: {
        default: () => import("../views/employee/faq.vue"),
        head: HeaderEmployee,
        footer: FooterEmployee,
      }
    },
    {
      path: '/help',
      name: 'help',
      components: {
        default: () => import("../views/employee/help.vue"),
        head: HeaderEmployee,
        footer: FooterEmployee,
      }
    },
    {
      path: '/terms-conditions',
      name: 'TNC',
      components: {
        default: () => import("../views/employee/TNC.vue"),
        head: HeaderEmployee,
        footer: FooterEmployee,
      }
    },
    {
      path: '/contact-us',
      name: 'ContactUS',
      components: {
        default: () => import("../views/employee/ContactUs.vue"),
        head: Header,
        footer: Footer,
      }
    },
    {
      path: '/privacy-policy',
      name: 'Privacy',
      components: {
        default: () => import("../views/employee/PrivacyPolicy.vue"),
        head: HeaderEmployee,
        footer: FooterEmployee,
      }
    },
    { path: '/:pathMatch(.*)*', redirect: '/' }

  ]
})

router.beforeEach((to, from, next) => {
  // Redirect if fullPath begins with a hash (ignore hashes later in path)
  if (to.fullPath.substr(0, 2) === "/#") {
    const path = to.fullPath.substr(2);
    next(path);
    return;
  }
  next();
});

export default router
